import { Injectable } from '@angular/core';
import { Http, Headers } from "@angular/http";
import  'rxjs/add/operator/map';
import { Observable } from "rxjs/Observable";
import { Component, Output } from '@angular/core';
import { parametros } from '../datos/parametros';


@Injectable()
export class httpService {

  @Output() uploaded: any = {

     estado: '',
     texto: ''

  }

  public modoOperador: boolean = false;

  datosPost = new parametros(0, 0, '');

  sw:any = {

    mostrarMenu:false,
    mostrarLogin:false,

    mostrarMaquinas:false,
    mostrarDatosmaquinas:false,

    mostrarPosiciones: false,
    mostrarDatosposiciones:false,

    mostrarClientes:false,
    mostrarDatosclientes:false,

    mostrarArticulos:false,
    mostrarDatosarticulos:false,

    mostrarTarifas:false,

    mostrarCargas: false,

    mostrarCargasOperador: false,

    mostrarMarcas:false,

    mostrarModelos:false,

    mostrarRecaudaciones:false,

    mostrarVisitas:false,

    mostrarFacturas:false,

    mostrarLotes: false

 };

  maquinaVacia:any = {
    Id:0,
    marca:1,modelo:1,
    posision:1,serie:'',
    contador:0,observaciones:'',
    fechaalta:'',
    descripcion:'',precio:0,
    porservicio:0,
    tipo:0,
    dias:0
  }

  posicionVacia:any = {
    Id:0, cliente:1,
    Direccion:'', Descripcion:'',
    PersonaContacto:'',
    Provincia:'', Poblacion:'',
    Telefono:'', Observaciones:''

  }

  clienteVacio:any = {
    Id:0, Nombre:'',direccion:'',poblacion:'',provincia:'',
    documento:'', telefono:'', telefono2:'', observaciones:''
  }

  articuloVacio:any = {
    Id:0, nombre:'', preciocompra:0, precioventa:0, iva:0
  }

  tarifaVacia:any = {
    Id:0, Maquina:0, Articulo:0, Precio:0
  }

  marcaVacia:any = {
    Id:0, marca:''
  }

  modeloVacio:any = {
    Id:0, modelo:''
  }

  recaudacionVacia:any = {
    Id:0, IdMaquina:0, IdPosicion:0, IdCliente:0, Importe:0, Cambio:0,
    Devolucion:0, Fecha:'', hora:'', contador:0, precioservicio:0

  }

  cargaVacia:any = {
    Id:0, IdMaquina:0, fecha:'', articulo:0, Unidades:0, pc:0, pv:0, oldFecha:'', oldMaquina:0
  }

 maquinaGrabar:any;
 posicionGrabar:any;
 clienteGrabar:any;
 articuloGrabar:any;
 tarifaGrabar:any;
 marcaGrabar:any;
 modeloGrabar:any;
 recaudacionGrabar:any;
 cargaGrabar:any;
 tarifacopiar:any;
 cargaMultiple:any = [];
 facturaGrabar:any;

 user:string ='';
 pass:string ='';
 operador: boolean = false;
 tituloMaquina:string = '';

 headers: Headers = new Headers();
  loading: boolean = false;

  constructor(private _http: Http) {
    this.setHeaders()
  }

  nuevaMaquina() {
    this.maquinaVacia.Id =0,
    this.maquinaVacia.marca=1,this.maquinaVacia.modelo=1,
    this.maquinaVacia.posision=1,this.maquinaVacia.serie='',
    this.maquinaVacia.contador=0,this.maquinaVacia.observaciones='',
    this.maquinaVacia.fechaalta='',
    this.maquinaVacia.descripcion='',this.maquinaVacia.precio=0,
    this.maquinaVacia.porservicio=0,this.maquinaVacia.tipo=0;
    this.maquinaVacia.dias = 0;
    this.maquinaVacia.visitas = 'FFFFFFFFFF'
    return this.maquinaVacia;
  }

  nuevaPosicion() {
      this.posicionVacia.Id=0, this.posicionVacia.cliente=1,
      this.posicionVacia.Direccion='', this.posicionVacia.Descripcion='',
      this.posicionVacia.PersonaContacto='',
      this.posicionVacia.Provincia='', this.posicionVacia.Poblacion='',
      this.posicionVacia.Telefono='', this.posicionVacia.Observaciones='';
      return this.posicionVacia;
    }

  nuevoCliente() {
        this.clienteVacio.Id=0, this.clienteVacio.Nombre='', this.clienteVacio.documento='',
        this.clienteVacio.direccion='', this.clienteVacio.poblacion='',
        this.clienteVacio.provincia='', this.clienteVacio.telefono='',
        this.clienteVacio.telefono2='', this.clienteVacio.observaciones='';
        return this.clienteVacio;
      }

  nuevoArticulo() {
      this.articuloVacio.Id = 0, this.articuloVacio.nombre = '', this.articuloVacio.preciocompra =0,
      this.articuloVacio.precioventa = 0, this.articuloVacio.iva=0;
      return this.articuloVacio;
  }

  nuevaTarifa() {
      this.tarifaVacia.Id = 0, this.tarifaVacia.Maquina = 0, this.tarifaVacia.Articulo = 0, this.tarifaVacia.Precio=0
      return this.tarifaVacia;
  }

  nuevaMarca() {
      this.marcaVacia.Id = 0, this.marcaVacia.marca = '';
      return this.marcaVacia;
  }

  nuevoModelo() {
      this.modeloVacio.Id = 0, this.modeloVacio.marca = '';
      return this.modeloVacio;
  }

  nuevaRecaudacion() {

    this.recaudacionVacia.Id=0, this.recaudacionVacia.IdMaquina=0,
    this.recaudacionVacia.IdPosicion=0,
    this.recaudacionVacia.IdCliente=0, this.recaudacionVacia.Importe=0,
    this.recaudacionVacia.Cambio=0, this.recaudacionVacia.Devolucion=0,
    this.recaudacionVacia.Fecha= this.hoy(), this.recaudacionVacia.hora = '00:00:00',
    this.recaudacionVacia.contador=0,
    this.recaudacionVacia.precioservicio=0
    return this.recaudacionVacia

  }

  nuevaCarga() {
    this.cargaVacia.Id=0, this.cargaVacia.IdMaquina=0, this.cargaVacia.fecha='',
    this.cargaVacia.articulo=0, this.cargaVacia.Unidades=0,
    this.cargaVacia.pc=0, this.cargaVacia.pv=0, this.cargaVacia.oldFecha='', this.cargaVacia.oldMaquina=0
    return this.cargaVacia
  }





  setHeaders() {

               this.headers.append('Access-Control-Allow-Headers', 'Content-Type');
               this.headers.append("Content-Type", "application/json");
  }


  hoy() {

      let today = new Date();
      let dd = today.getDate().toString();
      let mm = (today.getMonth() + 1).toString();
      let yyyy:string;


      if(today.getDate() < 10) {

        dd = '0'+ dd;
      }

      if (today.getMonth() < 10) {
        mm = '0'+ mm;
      }

      yyyy = today.getFullYear().toString();

      let fecha = dd + '-' + mm + '-' + yyyy;

      return  fecha;

   }


   fecha(f) {

       let today = new Date();
       let yyyy = f.substring(0,4);
       let mm = f.substring(5,7);
       let dd = f.substring(8,10);

       let fecha = dd + '-' + mm + '-' + yyyy;

       return  fecha;

    }


      hoyy() {  // hoy en formato yyyy-mm-dd

          let today = new Date();
          let dd = today.getDate().toString();
          let mm = (today.getMonth() + 1).toString();
          let yyyy:string;


          if(today.getDate() < 10) {

            dd = '0'+ dd;
          }

          if (today.getMonth() < 10) {
            mm = '0'+ mm;
          }

          yyyy = today.getFullYear().toString();

          let fecha = yyyy + '-' + mm + '-' + dd;

          return  fecha;

       }

  leerActivarMaquinas() {
    return this._http.get("https://www.grupovalenzuela.com/Duran/php/service.php?conf=1")
               .map( res => res.json());

  }

  grabarConf(accion) {
    return this._http.get("https://www.grupovalenzuela.com/Duran/php/service.php?grabarconf=1&accion="+accion)
               .map( res => res.json());

  }


  descargarLotes(Id) {
    this.loading = true;
    let url = "";
    if (Id == 0)
      url = "https://www.grupovalenzuela.com/Duran/php/service.php?lotes=1";
    if (Id > 0)
      url = "https://www.grupovalenzuela.com/Duran/php/service.php?lotes=2&Id="+Id;
    return this._http.get(url)
               .map( res => res.json());
  }


  descargarMaquinas(Id) {
    let url = "";
    if (Id == 0)
      url = "https://www.grupovalenzuela.com/Duran/php/service.php?maquinas=1";
    if (Id > 0)
      url = "https://www.grupovalenzuela.com/Duran/php/service.php?maquinas=2&Id="+Id;
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarPosiciones() {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?posiciones=1";
    return this._http.get(url)
               .map( res => res.json());
  }

  actualizarContador(contador, maquina) {
    let body = {
      contador: contador,
      maquina: maquina
    }
    console.log('Body: ', body)
    return this._http.post("https://www.grupovalenzuela.com/Duran/php/servicetest.php?updateContador=1", body)
               .map( res => res.json());
  }

  doSql(sql) {
    let body = {
      sql: sql
    }
    
    return this._http.post("https://www.grupovalenzuela.com/Duran/php/servicetest.php?sql=1", body)
               .map( res => res.json());
  }

  descargarFacturas(ini, fin) {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?facturas=1&i="+ini+"&f="+fin;
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarDetalleFacturas(Id) {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?detallefactura=1&id="+Id;
    return this._http.get(url)
               .map( res => res.json());
  }


  descargarconsultaPosiciones() {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?consultaposiciones=1";
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarClientes() {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?clientes=1";
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarArticulos() {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?articulos=1";
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarArticulosTarifa(maquina) {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?articulostarifa=1&m=" + maquina;
     (url);
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarArticulosMaquina(maquina) {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?articulosmaquina=1" + maquina;
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarTarifas(Id) {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?tarifas=1&Id="+Id;
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarMarcas() {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?marcas=1";
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarModelos() {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?modelos=1";
    return this._http.get(url)
               .map( res => res.json());
  }

  descargarRecaudaciones(ini:string, fin:string) {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?recaudaciones=1&i="+ini+"&f="+fin;
    return this._http.get(url)
               .map( res => res.json());
  }

 

  descargarCargas(ini:string, fin:string) {
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?consultacargas=1&i="+ini+"&f="+fin;
    //let url = "https://www.grupovalenzuela.com/Duran/php/service.php?lotes=8&i="+ini+"&f="+fin;
    return this._http.get(url)
               .map( res => res.json());

  }

  descargarCargasMaquina(fecha:string, maquina) {
    //let url = "https://www.grupovalenzuela.com/Duran/php/service.php?cargas=1&f="+fecha+"&m="+maquina;
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?lotes=8&f="+fecha+"&m="+maquina;
    return this._http.get(url)
               .map( res => res.json());

  }



  descargarDocs(Id) {

    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?docs=1&Id="+Id

    return this._http.get(url)
               .map( res => res.json());

  }


  public deleteFile(Id, fichero) {

          let url: string = 'https://www.grupovalenzuela.com/Duran/php/service.php?delete=1&Id=' + Id + '&f=' + fichero;

          return this._http.get(url)
              .map(res => res.json());

    }



  public uploadFile(formdata: any) {

         (formdata);
        let url: string = 'https://www.grupovalenzuela.com/Duran/php/fileUpload.php';
        return this._http.post(url, formdata)
            .map(res => res.json());

  }

  hacer_login(user, pass){
    let url = "https://www.grupovalenzuela.com/Duran/php/service.php?login=1&user="+ user + '&pass=' + pass;
    return this._http.get(url)
               .map( res => res.json());
  }

  maquina(maquina) {
    console.log('Mq: ', maquina)
    let url: string = 'https://www.grupovalenzuela.com/Duran/php/maquina.php';
    return this._http.post(url, maquina)
        .map(res => res.json());
  }

  lotes(lote) {
    console.log('Lote: ', lote)
    let url: string = 'https://www.grupovalenzuela.com/Duran/php/service.php?lotes=' + this.datosPost.action;
    return this._http.post(url, lote)
        .map(res => res.json());
  }

  posicion(posicion) {

    let url: string = 'https://www.grupovalenzuela.com/Duran/php/posicion.php';
    return this._http.post(url, posicion)
        .map(res => res.json());
  }

  cliente(cliente) {

    let url: string = 'https://www.grupovalenzuela.com/Duran/php/clientes.php';
    return this._http.post(url, cliente)
        .map(res => res.json());
  }

  articulo(articulo) {

    let url: string = 'https://www.grupovalenzuela.com/Duran/php/articulos.php';
    return this._http.post(url, articulo)
        .map(res => res.json());
  }

  tarifa(tarifa) {

    let url: string = 'https://www.grupovalenzuela.com/Duran/php/tarifas.php';
    return this._http.post(url, tarifa)
        .map(res => res.json());
  }

  marca(marca) {

    let url: string = 'https://www.grupovalenzuela.com/Duran/php/marcas.php';
    return this._http.post(url, marca)
        .map(res => res.json());
  }

  modelo(modelo) {

    let url: string = 'https://www.grupovalenzuela.com/Duran/php/modelos.php';
    return this._http.post(url, modelo)
        .map(res => res.json());
  }

  recaudacion(recaudacion) {

    let url:string = 'https://www.grupovalenzuela.com/Duran/php/recaudaciones.php';
    return this._http.post(url, recaudacion)
        .map(res => res.json());
  }

  cargas(carga) {

    console.log(carga)

    let url:string = 'https://www.grupovalenzuela.com/Duran/php/cargas.php';
    return this._http.post(url, carga)
        .map(res => res.json());
  }


  facturas(factura) {

    console.log("En factura: ", factura)

    let url:string = 'https://www.grupovalenzuela.com/Duran/php/facturas.php';
    return this._http.post(url, factura)
        .map(res => res.json());
  }

  detallefactura(detalle) {

    console.log("En http detalle: ", detalle)

    let url:string = 'https://www.grupovalenzuela.com/Duran/php/detallefactura.php';
    return this._http.post(url, detalle)
        .map(res => res.json());
  }





  miReplace(string, target, replacement) {
     var i = 0, length = string.length;
     for (i; i < length; i++) {
       string = string.replace(target, replacement);
     }
     return string;
  }





}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/service/servicio.ts